export default __webpack_public_path__ + "a8cd359506108cfab0468c26830cdc4a.svg";